export default __webpack_public_path__ + "static/thank-you-success-f14ac87b1741e4daa495412c4e931a04.png";